import { NavLink } from 'react-router-dom';
import { useAuth } from '../lib/auth';

/** Tabs shared by every Architectural Review page. */
export function ArchNav() {
  const { isReviewer, isSuperAdmin } = useAuth();
  const manager = isReviewer || isSuperAdmin;
  const links = [
    { to: '/architecture/guide', label: 'Ask AI' },
    { to: '/architecture', label: isReviewer ? 'Review queue' : 'My Requests', end: true },
    { to: '/architecture/resources', label: 'Resources' },
    { to: '/architecture/guidelines', label: 'Written rules' },
    ...(manager ? [{ to: '/architecture/sources', label: 'Knowledge Sources' }] : []),
  ];
  return (
    <nav className="chip-row" aria-label="Architectural Review">
      {links.map((link) => (
        <NavLink key={link.to} to={link.to} end={link.end} className={({ isActive }) => `chip${isActive ? ' on' : ''}`}>
          {link.label}
        </NavLink>
      ))}
    </nav>
  );
}
